import { Accordion, Text } from "@ucl/react-library";
import { Trans, useTranslation } from "react-i18next";
import { translationMapping } from "src/utils/translation-mappings";

export const PayingAnotherWay = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-5" data-testid="payingAnotherWay">
      <Text renderAs="h3" styleType="h4" fontWeight="semi-bold">{t("bankDetailsForm.payingAnotherWay")}</Text>
      <Accordion>
        <Accordion.Item id="1" title={t("bankDetailsForm.nonUkBankAccountsTitle")} titleSize="small">
          <Accordion.Panel>
            <Text.P size="large"><Trans i18nKey={"bankDetailsForm.nonUkBankAccountsBody"} components={translationMapping(t)} /></Text.P>
          </Accordion.Panel>
        </Accordion.Item>
        <Accordion.Item id="2" title={t("bankDetailsForm.alternativePaymentTitle")} titleSize="small">
          <Accordion.Panel>
            <Text.P size="large"><Trans i18nKey={"bankDetailsForm.alternativePaymentBody"} components={translationMapping(t)} /></Text.P>
          </Accordion.Panel>
        </Accordion.Item>
      </Accordion>
    </div>
  );
};